import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../../../../../../models/enums.generated';
import { camps } from '../../../../../../../../../models/models.generated';
import { OptionManagementApiService } from '../../../../../../../../../services/api/option-management-api.service';
import { CampsEnumTranslationService } from '../../../../../../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../../../../../../camp-details-form-state-service';

@Component({
    selector: 'app-option-details-edit',
    templateUrl: './option-details-edit.component.html',
    styleUrls: ['./option-details-edit.component.scss'],
    standalone: false
})
export class OptionDetailsEditComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    @Input() context: camps.CampDefinitionCreationContext;

    @Output() canceled: EventEmitter<UntypedFormGroup> = new EventEmitter();

    constructor(
        private state: CampsDetailsFormStateService,
        private enumTranslation: CampsEnumTranslationService,
        private api: OptionManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public save() {
        this.setPrice();

        var request = <camps.OptionsSaveRequest>{
            optionId: this.form.get('id').value,
            sessionId: this.form.get('sessionId').value,
            name: this.form.get('name').value,
            order: this.form.get('order').value,
            pricePerSession: this.form.get('pricePerSession').value,
            type: this.form.get('type').value,
            description: this.form.get('description').value
        };

        this.api.save(request).subscribe(x => {
            if (x.isSuccess) {
                this.alert.showOperationSuccess();
                this.form.get('id').setValue(x.value.id);
                this.state.finishEdit(this.form);
                this.state.sessionChanged.emit(request.sessionId);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }

    public cancel() {
        this.canceled.emit(this.form);
    }

    private setPrice() {
        var price = FormService.getAmountFromCurrencyMask(this.form.controls['pricePerSession'].value);
        this.form.controls['pricePerSession'].setValue(price);
    }

    public changeType(value: campsenum.OptionType) {
        this.form.controls['type'].setValue(value);
    }

    public translateType(type: campsenum.OptionType) {
        return this.enumTranslation.optionType(type);
    }

    public isFormValid() {
        return FormService.isFormValid(this.form);
    }
}
